var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: { title: _vm.$t("COMMON_DELETE"), visible: "", width: "40%" },
      on: { close: _vm.onCancel },
    },
    [
      _c("div", { staticClass: "wl-title" }, [
        _vm._v(_vm._s(_vm.$t("SITE_APPROVAL_DESC"))),
      ]),
      _c(
        "el-form",
        {
          ref: "ruleForm",
          staticClass: "demo-ruleForm",
          attrs: {
            model: _vm.ruleForm,
            rules: _vm.rules,
            "label-width": "120px",
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("SITE_APPROVER"), prop: "approver" } },
            [
              _c("el-input", {
                attrs: { maxlength: "50" },
                model: {
                  value: _vm.ruleForm.approver,
                  callback: function ($$v) {
                    _vm.$set(_vm.ruleForm, "approver", $$v)
                  },
                  expression: "ruleForm.approver",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            { staticClass: "wl-grey", on: { click: _vm.onCancel } },
            [_vm._v(_vm._s(_vm.$t("comment_reSet")))]
          ),
          _c(
            "el-button",
            {
              staticClass: "wl-green",
              attrs: { type: "primary" },
              on: { click: _vm.onConfirm },
            },
            [_vm._v(_vm._s(_vm.$t("btn_save")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }